import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../../../reducers';

const sliceSelector = (state: StorageState) => state.users.roles.list;

export const accessRolesListSelector = () => createSelector(sliceSelector, state => state.list);
export const accessRolesLoading = () => createSelector(sliceSelector, state => state.isLoading);
export const accessRolesLoaded = () => createSelector(sliceSelector, state => state.isLoaded);
